import { styled } from "@mui/material/styles";
import {
    FormControl,
    FormControlLabel,
    FormLabel,
    InternalStandardProps,
    Radio,
    RadioGroup,
    RadioGroupProps,
} from "@mui/material";

const StyledFormControl = styled(FormControl)({});

const StyledLabel = styled(FormControlLabel)<{ variant?: string }>(({ theme, variant }) => ({
    "& .MuiFormControlLabel-label": {
        fontSize: variant === "large" ? "2rem" : "1rem",
        marginLeft: variant === "large" ? theme.spacing(2) : theme.spacing(1),
        color: theme.palette.grey[800],
    },
}));

const StyledRadio = styled(Radio)(({ theme }) => ({
    color: theme.palette.grey[800],
    margin: theme.spacing(1, 0),
    "&.Mui-checked": {
        color: theme.palette.grey[800],
    },
    "& .MuiSvgIcon-root": {
        fontSize: 28,
    },
}));

export interface AppRadioGroupProps
    extends InternalStandardProps<RadioGroupProps> {
    radios: {
        label: string;
        value: string;
    }[];
    label?: string;
    variant?: string;
}

export const AppRadioGroup = (props: AppRadioGroupProps) => {
    const {
        className,
        label,
        defaultValue,
        radios,
        variant = "large",
        ...rest
    } = props;

    return (
        <StyledFormControl className={className}>
            {label && <FormLabel>{label}</FormLabel>}
            <RadioGroup {...rest}>
                {radios.map((d) => (
                    <StyledLabel
                        key={d.value}
                        variant={variant}
                        value={d.value}
                        control={<StyledRadio />}
                        label={d.label}
                    />
                ))}
            </RadioGroup>
        </StyledFormControl>
    );
};
